import { createFileRoute } from "@tanstack/react-router";

import MakeASuggestionPage from "@/features/make-a-suggestion";

export const Route = createFileRoute("/_auth/_app-shell/make-a-suggestion")({
  component: MakeASuggestionPage,
  head: () => ({ meta: [{ title: "Make a Suggestion - NoLimit Creatives" }] }),
});
